export const InvoiceModuleResourceKeys = {
    common: {
        downloadAllFiles: 'inv.common.downloadAllFiles',
        totalFiles: 'inv.common.totalFiles',
    },
    list: {
        action: 'inv.list.action',
        alternateBillClient: 'inv.list.alternateBillClient',
        clientName: 'inv.list.clientName',
        currency: 'inv.list.currency',
        deliveryMethod: 'inv.list.deliveryMethod',
        id: 'inv.list.id',
        internalOrganization: 'inv.list.internalOrganization',
        invoiceDate: 'inv.list.invoiceDate',
        invoiceNumber: 'inv.list.invoiceNumber',
        invoicingType: 'inv.list.invoicingType',
        noOfAttachments: 'inv.list.noOfAttachments',
        noOfTransactions: 'inv.list.noOfTransactions',
        paymentTerms: 'inv.list.paymentTerms',
        status: 'inv.list.status',
        subtotal: 'inv.list.subtotal',
        template: 'inv.list.template',
        total: 'inv.list.total',
        totalTax: 'inv.list.totalTax',
        poNumber: 'inv.list.poNumber',
        startDate: 'inv.list.startDate',
        endDate: 'inv.list.endDate',
        worker: 'inv.list.worker',
        reason:'inv.list.reason',
        billingFrequency:'inv.list.billingFrequency',
        note: 'inv.list.note'
    },
    detail: {
        billingClientLabel: 'inv.detail.billingClientLabel',
        clientCourtesyCopiesTitle: 'inv.detail.clientCourtesyCopiesTitle',
        clientNameHeader: 'inv.detail.clientNameHeader',
        confirmationMessage: 'inv.detail.confirmationMessage',
        confirmContinueMessage: 'inv.detail.confirmContinueMessage',
        confirmInvoiceMarkAsPaidUnpaidBillingTransactions: 'inv.detail.confirmInvoiceMarkAsPaidUnpaidBillingTransactions',
        detailsTitle: 'inv.detail.detailsTitle',
        detailTab: 'inv.detail.detailTab',
        documentsTab: 'inv.detail.documentsTab',
        historyTab: 'inv.detail.historyTab',
        idHeader: 'inv.detail.idHeader',
        internalCourtesyCopiesTitle: 'inv.detail.internalCourtesyCopiesTitle',
        internalOrganizationHeader: 'inv.detail.internalOrganizationHeader',
        invoiceDateLabel: 'inv.detail.invoiceDateLabel',
        invoiceNotesTitle: 'inv.detail.invoiceNotesTitle',
        invoiceNumberHeader: 'inv.detail.invoiceNumberHeader',
        invoiceReleaseDateLabel: 'inv.detail.invoiceReleaseDateLabel',
        invoiceTermLabel: 'inv.detail.invoiceTermLabel',
        invoiceToLabel: 'inv.detail.invoiceToLabel',
        noClientCourtesyCopiesMessage: 'inv.detail.noClientCourtesyCopiesMessage',
        noInternalCourtesyCopiesMessage: 'inv.detail.noInternalCourtesyCopiesMessage',
        noProfileMessage: 'inv.detail.noProfileMessage',
        note1Label: 'inv.detail.note1Label',
        note2Label: 'inv.detail.note2Label',
        note3Label: 'inv.detail.note3Label',
        note4Label: 'inv.detail.note4Label',
        recipientTitle: 'inv.detail.recipientTitle',
        statusHeader: 'inv.detail.statusHeader',
        templateLabel: 'inv.detail.templateLabel',
        totalAmountHeader: 'inv.detail.totalAmountHeader',
        transactionsTab: 'inv.detail.transactionsTab',
        CCDeliveryToLabel: 'inv.detail.CCDeliveryToLabel',
        invoiceDeleted: 'inv.detail.Invoice_Deleted',
        FileExportFormatLabel: 'inv.detail.FileExportFormatLabel'
    },
    transactions: {
        actionColumnHeader: 'inv.transactions.actionColumnHeader',
        addBtn: 'inv.transactions.addBtn',
        addTransactionToInvoiceTitle: 'inv.transactions.addTransactionToInvoiceTitle',
        agencyColumnHeader: 'inv.transactions.agencyColumnHeader',
        alternateBillClientColumnHeader: 'inv.transactions.alternateBillClientColumnHeader',
        billingInvoiceTemplateColumnHeader: 'inv.transactions.billingInvoiceTemplateColumnHeader',
        billingTransactionNumberColumnHeader: 'inv.transactions.billingTransactionNumberColumnHeader',
        billRateColumnHeader: 'inv.transactions.billRateColumnHeader',
        branchColumnHeader: 'inv.transactions.branchColumnHeader',
        clientManagerColumnHeader: 'inv.transactions.clientManagerColumnHeader',
        deliveryMethodColumnHeader: 'inv.transactions.deliveryMethodColumnHeader',
        endDateColumnHeader: 'inv.transactions.endDateColumnHeader',
        idColumnHeader: 'inv.transactions.idColumnHeader',
        invoiceNote1ColumnHeader: 'inv.transactions.invoiceNote1ColumnHeader',
        invoiceNote2ColumnHeader: 'inv.transactions.invoiceNote2ColumnHeader',
        invoiceNote3ColumnHeader: 'inv.transactions.invoiceNote3ColumnHeader',
        invoiceNote4ColumnHeader: 'inv.transactions.invoiceNote4ColumnHeader',
        invoiceToColumnHeader: 'inv.transactions.invoiceToColumnHeader',
        openTimesheetTitle: 'inv.transactions.openTimesheetTitle',
        openTransactionTitle: 'inv.transactions.openTransactionTitle',
        openWorkorderTitle: 'inv.transactions.openWorkorderTitle',
        paymentTermsColumnHeader: 'inv.transactions.paymentTermsColumnHeader',
        projectNameColumnHeader: 'inv.transactions.projectNameColumnHeader',
        purchaseOrderNumberColumnHeader: 'inv.transactions.purchaseOrderNumberColumnHeader',
        rateUnitColumnHeader: 'inv.transactions.rateUnitColumnHeader',
        removeTransactionHeader: 'inv.transactions.removeTransactionHeader',
        removeTransactionMessage: 'inv.transactions.removeTransactionMessage',
        startDateColumnHeader: 'inv.transactions.startDateColumnHeader',
        subtotalColumnHeader: 'inv.transactions.subtotalColumnHeader',
        totalAmountLabel: 'inv.transactions.totalAmountLabel',
        totalBillColumnHeader: 'inv.transactions.totalBillColumnHeader',
        totalTaxColumnHeader: 'inv.transactions.totalTaxColumnHeader',
        transactionDateColumnHeader: 'inv.transactions.transactionDateColumnHeader',
        transactionTypeColumnHeader: 'inv.transactions.transactionTypeColumnHeader',
        unitsColumnHeader: 'inv.transactions.unitsColumnHeader',
        workerColumnHeader: 'inv.transactions.workerColumnHeader',
        workerTypeColumnHeader: 'inv.transactions.workerTypeColumnHeader',
        workOrderNumberColumnHeader: 'inv.transactions.workOrderNumberColumnHeader',
        worksiteColumnHeader: 'inv.transactions.worksiteColumnHeader'
    },
    documents: {
        amountLabel: 'inv.documents.amountLabel',
        currencyLabel: 'inv.documents.currencyLabel',
        docTypeLabel: 'inv.documents.docTypeLabel',
        documentReviewLabel: 'inv.documents.documentReviewLabel',
        errorChangingDocumentStatusMessage: 'inv.documents.errorChangingDocumentStatusMessage',
        fileLabel: 'inv.documents.fileLabel',
        fileNameLabel: 'inv.documents.fileNameLabel',
        idLabel: 'inv.documents.idLabel',
        invoiceLabel: 'inv.documents.invoiceLabel',
        periodLabel: 'inv.documents.periodLabel',
        rateUnitLabel: 'inv.documents.rateUnitLabel',
        transactionNumberLabel: 'inv.documents.transactionNumberLabel',
        transactionTypeLabel: 'inv.documents.transactionTypeLabel',
        unitsLabel: 'inv.documents.unitsLabel',
        workerLabel: 'inv.documents.workerLabel',
        workOrderLabel: 'inv.documents.workOrderLabel',
    },
};
